import React, { useEffect, useMemo, useState, memo } from "react";
import Header from "../../../layout/Header";
import CampaignDetailsTab from "../common/CampaignDetailsTab";
import EditEarningRulesTabLoyalty from "./EditEarningRulesTabLoyalty";
import { backIcon2 } from "../../../../Image/Index";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Tabs, Tab } from "react-bootstrap";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
import CommunicationFlowTab from "../common/CommunicationFlowTab";
import { decrypt } from "../../../../utils/encodingdecoding";
import { getCampaign, clearCampaigns } from "../../../../actions/campaigns";

import { getDate, handleClick } from "../../../../utils/helper";
const EditLoyaltyCampaign = ({ clearCampaigns, getCampaign, Campaigns }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  const codeId = id;
  const { data, type, sampleFor } = location?.state || {};
  const [key, setKey] = useState("Campaign Details");
  const [loader, setLoader] = useState(true);
  const [formPage, setFormPage] = useState();
  const [formData, SetFormData] = useState({
    version: "15",
    code: "",
    coalitionCampaignCode: null,
    coalitionProgramCode: null,
    status: true,
    priority: 999,
    name: "",
    businessGoal: "",
    description: null,
    timeZone: "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi",
    isTest: false,
    isVisibile: true,
    startDateTime: "2022-08-24T00:00:00",
    endDateTime: "2023-12-31T00:00:00",
    visibilityDateTime: "0001-01-01T00:00:00",
    offerDetail: {
      offerCode: "",
      title: "Referral Campaign",
      programCode: null,
      internalLink: null,
      selectedImg: null,
      externalLink: null,
      imageLink: null,
      mobileImageLink: null,
      logoImageLink: null,
      description:
        data?.offerDetail?.title === "Referral campaign" ? "referral" : "",
      redemptionProcess: null,
      escalationMatrix: null,
      termAndCondition: null,
      purchaseable: {
        isPurchaseable: false,
        isActivated: false,
        price: 0,
        validityPeriod: 86400,
        validityPeriodType: 0,
        isImported: false,
        voucherTemplate: null,
      },
      longDescription: null,
    },
    tags: [],
    internalTags: [],
    earningRule: {
      earningRuleEvalutionType: 2,
      rules: [
        {
          infixRule: [
            {
              entityName: "",
              field: "",
              jsonPath: "",
              op: "",
              value: [],
              type: "",
              format: null,
            },
          ],
          prefixRule: {
            condition: "AND",
            rules: [
              {
                id: "",
                field: "",
                type: "",
                input: "",
                operator: "",
                value: "",
                data: {
                  class: "Transaction",
                },
              },
            ],
            valid: true,
          },
          data: [
            {
              RedeemType: "",
              Value: 0,
              isEvery: false,
              RewardRatio: 0,
              EarnigWho: "Customer",
              Sponsors: [
                {
                  Type: "Merchant",
                  Code: decrypt(localStorage.getItem("merchantcode")),
                  Percent: 100,
                },
              ],
              redeemRule: {
                redeemRuleBy: false,
                afterSpecificTransaction: false,
              },
              expirationRule: {
                onAfter: true,
                afterSpecificNumber: 0,
                afterDuration: "",
              },
            },
          ],
          function: [
            {
              infixRule: [],
              prefixRule: null,
              duration: null,
            },
          ],
          dbFunctionRule: [
            {
              sqlRule: null,
              infixRule: [],
              prefixRule: null,
            },
          ],
        },
      ],
    },
    InfixQualifyingRules: [],
    PrefixQualifyingRules: [],
    merchantTransactionSchema: {
      schemaId: localStorage.getItem("SchemaID"),
      schemaName: data?.merchantTransactionSchema?.schemaName,
      merchants: [decrypt(localStorage.getItem("merchantcode"))],
    },
    processingMode: "",
    approvalStatus: 1,
    restrictedPrograms: [],
    campaignGlobalLimit: {
      isGlobalCampaignLimit: false,
      globalLimits: [
        {
          walletKey: "point",
          walletName: "point",
          maxLimit: 0,
          isDailyLimit: false,
          dailyLimit: 0,
          limitConsumed: 0,
          limitRemained: 0,
          liveConsumptionStatus: null,
        },
        {
          walletKey: "discount",
          walletName: "discount",
          maxLimit: 0,
          isDailyLimit: false,
          dailyLimit: 0,
          limitConsumed: 0,
          limitRemained: 0,
          liveConsumptionStatus: null,
        },
        {
          walletKey: "currency",
          walletName: "currency",
          maxLimit: 0,
          isDailyLimit: false,
          dailyLimit: 0,
          limitConsumed: 0,
          limitRemained: 0,
          liveConsumptionStatus: null,
        },
      ],
    },
    campaignCustomerLimit: {
      isCustomerLimit: false,
      customerLimits: [
        {
          walletKey: "point",
          walletName: "point",
          maxLimit: 0,
          timePeriod: "2",
          limit: 0,
        },
        {
          walletKey: "discount",
          walletName: "discount",
          maxLimit: 0,
          timePeriod: "2",
          limit: 0,
        },
        {
          walletKey: "currency",
          walletName: "currency",
          maxLimit: 0,
          timePeriod: "2",
          limit: 0,
        },
      ],
    },
    selfMadeCampaign: false,
    taglastcheck: null,
    Type: "",
    Range: 0,
    Tiers: null,
    Membership: null,
    merchantId: [decrypt(localStorage.getItem("merchantcode"))],
  });

  const [error, setError] = useState({
    errName: false,
    errNameMsg: "Please enter campaign name",
    errBusiness: false,
    errBusinessMsg: "Please select business goal",
    errStartDate: false,
    errStartDateMsg: "Please select start date",
    errEndDate: false,
    errEndDateMsg: "Please select end date",
    errDateDiff: false,
    errDateDiffMsg: "Start date cannot be greater than or equal to End date.",
    errProcessing: false,
    errProcessingMsg: "Please select Processing Mode",
  });
  useEffect(() => {
    const fetch = async () => {
      clearCampaigns();
      setLoader(true);
      const token = JSON.parse(localStorage.getItem("token_gen"));
      await getCampaign(token?.access_token, codeId);
      setLoader(false);
    };
    fetch();
  }, []);

  useEffect(() => {
    if (type) {
      const nextSixMonth = handleClick();
      data.startDateTime = getDate(new Date(), "YYYY-MM-DD");
      data.endDateTime = nextSixMonth;
      data.earningRule.rules[0].data[0].Sponsors = [
        {
          Type: "Merchant",
          Code: decrypt(localStorage.getItem("merchantcode")),
          Percent: 100,
        },
      ];
      SetFormData(data);
    } else {
      const fromStore = Campaigns?.data?.[0];
      const campaign =
        fromStore && String(fromStore.code) === String(codeId)
          ? fromStore
          : data && String(data.code) === String(codeId)
            ? data
            : null;
      if (!campaign) return;
      SetFormData(campaign);
      setFormPage(campaign?.earningRule?.rules?.[0]?.data?.[0]?.AccountType);
      return;
    }
    setFormPage(Campaigns?.data?.[0]?.earningRule?.rules[0]?.data[0]?.AccountType);
  }, [Campaigns]);
  useEffect(() => {
    clearCampaigns();
  }, []);

  const { errDateDiff } = error;

  let tempName = false,
    tempStartDate = false,
    tempEndDate = false,
    tempBusiness = false,
    tempProcessing = false;

  useEffect(() => {
    if (formData.startDateTime >= formData.endDateTime) {
      setError({ ...error, errDateDiff: true });
    } else {
      setError({ ...error, errDateDiff: false });
    }
  }, [formData.startDateTime, formData.endDateTime]); //eslint-disable-line

  const onChange = (e) => {
    if (e.target?.name === "status") {
      SetFormData({ ...formData, ...{ status: e.target.value } });
    } else if (e.target?.name === "tags") {
      let formattedTags = [];

      if (e.target.value && e.target.value.value !== "") {
        formattedTags.push(
          `${e.target.value.value}:${e.target.value.value}:null`
        );
      }
      SetFormData({ ...formData, tags: formattedTags });
    }
    if (e.target?.name === "businessGoal") {
      SetFormData({ ...formData, ...{ businessGoal: e.value } });
    }
    if (e.target?.name === "processingMode") {
      SetFormData({ ...formData, ...{ processingMode: e.target.value.type } });
    } else if (e?.editor?.getData().length > 0) {
      SetFormData({ ...formData, ...{ description: e?.editor?.getData() } });
    } else {
      SetFormData({ ...formData, ...{ [e?.target?.name]: e?.target?.value } });
    }

    if (formData.name !== "") {
      tempName = false;
    }
    if (formData.startDateTime !== "") {
      tempStartDate = false;
    }
    if (formData.endDateTime !== "") {
      tempEndDate = false;
    }
    if (formData.businessGoal !== null) {
      tempBusiness = false;
    }
    if (formData.processingMode !== null) {
      tempProcessing = false;
    }
    setError({
      ...error,
      errName: tempName ? true : false,
      errEndDate: tempEndDate ? true : false,
      errStartDate: tempStartDate ? true : false,
      errBusiness: tempBusiness ? true : false,
      errProcessing: tempProcessing ? true : false,
    });
  };

  useEffect(() => {
    if (Array.isArray(formData?.tags) && formData.tags.length > 0) {
      const formattedTags =
        formData.tags[0]?.TagKey
          ? formData.tags.map(
            (tag) => `${tag.TagKey}:${tag.TagKey}:#d81313`
          )
          : formData.tags;

      SetFormData((prev) => ({
        ...prev,
        tags: formattedTags,
      }));
    }
  }, [formData?.tags[0]]);

  const handleTabChange = (callback) => {
    if (formData.name === "") {
      tempName = true;
    }
    if (formData.startDateTime === "") {
      tempStartDate = true;
    }
    if (formData.endDateTime === "") {
      tempEndDate = true;
    }
    if (formData.businessGoal === undefined) {
      tempBusiness = true;
    }
    if (formData.processingMode === "") {
      tempProcessing = true;
    }
    if (
      !tempName &&
      !tempStartDate &&
      !tempEndDate &&
      !errDateDiff &&
      !tempBusiness &&
      !tempProcessing
    ) {
      callback.key && setKey(callback.key);
    }

    setError({
      ...error,
      errName: tempName ? true : false,
      errEndDate: tempEndDate ? true : false,
      errStartDate: tempStartDate ? true : false,
      errBusiness: tempBusiness ? true : false,
      errProcessing: tempProcessing ? true : false,
    });
  };

  const handleSelect = (k) => {
    setKey(k);
  };
  const handleNavigateBack = () => {
    location?.state?.tags && navigate(-1, { state: location?.state?.tags });
    !location?.state?.tags && navigate("/my-campaign");
  };

   const handleImgUpload = (filedata) => {
    SetFormData((prev) => ({
      ...prev,
      offerDetail: {
        ...prev.offerDetail,
        selectedImg: filedata || null,
        imageLink: "",
      },
    }));
  };

  const renderCampaignDetailsTab = useMemo(() => {
    return (
      <CampaignDetailsTab
        onChange={(e) => onChange(e)}
        formateData={formData}
        error={error}
        handleTabChange={handleTabChange}
        handleImgUpload={handleImgUpload}
        SetFormateData={SetFormData}
      />
    );
  }, [formData, error, handleImgUpload]); //eslint-disable-line
  const renderEarningRulesTab = useMemo(() => {
    return (
      <EditEarningRulesTabLoyalty
        onChange={(e) => onChange(e)}
        formPage={formPage}
        formateData={formData}
        type={type}
        merchantTransactionSchema={data}
        tags={location?.state?.tags}
        handleTabChange={handleTabChange}
        currentTab={key}
        sampleFor={sampleFor}
      />
    );
  }, [formData]);
  //eslint-disable-line

  return (
    <>
      <Header
        name={
          type === "sample" ? (
            sampleFor === "view" ? (
              "View Sample Campaigns"
            ) : (
              "Edit Sample Campaigns"
            )
          ) : (
            <span
              style={{ textTransform: "capitalize" }}
            >{`Edit ${data?.offerDetail?.title || ""}`}</span>
          )
        }
      />
      {loader && (
        <div className="mainPreloaderMain">
          <div className="mainPreloader">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      )}
      <div className="dashboard__content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="dashboard__heading">
                <div className="dashboard__headingLeft">
                  <div className="dashboard__headingBackLink">
                    <button onClick={handleNavigateBack}>
                      <img src={backIcon2} alt="" />
                    </button>
                  </div>
                  <div className="dashboard__headingContent">
                    <h3>
                      {type === "sample" ? (
                        sampleFor === "view" ? (
                          "View Sample Campaigns"
                        ) : (
                          "Edit Sample Campaigns"
                        )
                      ) : (
                        <span
                          style={{ textTransform: "capitalize" }}
                        >{`Edit ${data?.name || ""}`}</span>
                      )}
                    </h3>
                    <p>
                      {type === "sample"
                        ? sampleFor === "view"
                          ? "How"
                          : "Edit how"
                        : "Edit how"}{" "}
                      your customers will earn points
                    </p>
                  </div>
                </div>
              </div>
              <div className="dashboard__tabSection">
                <Tabs
                  id="controlled-tab-example"
                  activeKey={key}
                  onSelect={handleSelect}
                  onClick={handleTabChange}
                >
                  <Tab
                    eventKey="Campaign Details"
                    id="cpm_deta"
                    title="Campaign Details"
                  >
                    {renderCampaignDetailsTab}
                  </Tab>
                  <Tab
                    eventKey="Rules"
                    title="Rules"
                    id="kd"
                    disabled={
                      type !== "sample"
                        ? formData.name &&
                          formData.endDateTime &&
                          formData.startDateTime &&
                          formData.businessGoal &&
                          error.errDateDiff === false
                          ? false
                          : true
                        : false
                    }
                  >
                    {renderEarningRulesTab}
                  </Tab>
                  {type !== "sample" && (
                    <Tab
                      eventKey="Communication Flow"
                      id="communication_flow"
                      title="Communication Flow"
                      disabled={
                        formData.name &&
                          formData.endDateTime &&
                          formData.startDateTime &&
                          formData.businessGoal &&
                          error.errDateDiff === false
                          ? false
                          : true
                      }
                    >
                      {key === "Communication Flow" && (
                        <CommunicationFlowTab code={formData?.code} />
                      )}
                    </Tab>
                  )}
                </Tabs>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
const mapStateToProps = (state) => ({
  Campaigns: state.Campaigns,
});
const mapDispatchToProps = {
  getCampaign,
  clearCampaigns,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(memo(EditLoyaltyCampaign));
